export enum NuiTagSize {
    sm = 'sm',
    md = 'md',
    lg = 'lg'
}
export enum NuiTagBgr {
    'pure-white' = 'pure-white',
    gold = 'gold',
    burgundy = 'burgundy',
    'light-grey' = 'light-grey',
    'dark-grey' = 'dark-grey',
    'orange-gradient' = 'orange-gradient'
}

export type NuiTagSizeType = keyof typeof NuiTagSize;
export type NuiTagBgrType = keyof typeof NuiTagBgr;

export interface NuiTagType {
    size?: NuiTagSizeType;
    bgr?: NuiTagBgrType;
    otherClass?: string;
    dataAtid?: string;
}
